<script>
  import { Icon, PhoneOutgoing } from 'svelte-hero-icons';

  import FootNav from './foot-nav.svelte';
  import BaseFooter from './base.svelte';
  import QrCode from './qrcode.svelte';
</script>

<style>
  .ti-footer {
    position: relative;
  }
  .ti-footer:before {
    position: absolute;
    left: 0;
    top: 85px;
    content: "";
    display: block;
    height: 1px;
    width: 100%;
    background: #eee;
  }
</style>

<footer class="ti-footer mt-8 py-6 bg-white">
  <div class="ti-container">
    <div class="flex flex-col md:flex-row gap-12 content-start justify-between py-4">
      <!-- Footer Menu -->
      <FootNav />

      <div class="flex flex-col items-center">
        <!-- <p class="inline-flex items-center font-medium mb-4 md:mb-8">
          <Icon src={PhoneOutgoing} solid class="h-6 w-6 mr-2 text-red-400" />
          XXX-XXXXXXXX
        </p> -->
        <p class="md:h-14"></p>
        <QrCode />
      </div>
    </div>

    <div class="pt-4 mt-6 text-center border-t border-gray-100">
      <BaseFooter />
    </div>
  </div>
</footer>
